"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userSelectedFullImageToImage = void 0;
const userSelectedFullImageToImage = ({ notAvailableImageUrl, userImage, }) => ({
    height: userImage.height,
    id: userImage.id,
    private: !!userImage.userId && !!userImage.image.source,
    thumbnailUrl: userImage.image.deleted_at
        ? undefined
        : userImage.image.thumbnailUrl,
    url: userImage.image.deleted_at ? notAvailableImageUrl : userImage.image.url,
    width: userImage.width,
    x_offset: userImage.xOffset,
    y_offset: userImage.yOffset,
});
exports.userSelectedFullImageToImage = userSelectedFullImageToImage;
//# sourceMappingURL=image_utils.js.map